import { createSlice } from "@reduxjs/toolkit";
import getUrgencyApi from "@custom/rtk-apis/billing/urgency/getUrgency";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getUrgencySlice = createSlice({
  name: "getUrgencySlice",
  initialState,
  reducers: {
    clearGetUrgency: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUrgencyApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getUrgencyApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(getUrgencyApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getUrgencySlice.reducer;
export const { clearGetUrgency } = getUrgencySlice.actions;
